module.exports = __webpack_public_path__ + "img/icon_popup_close@3x.d3664c25.png";